import { createFileRoute } from '@tanstack/react-router';
import Flows from 'containers/Flows';

export const Route = createFileRoute('/_authenticated/flows')({
  component: Flows,
});
